import React, {useContext} from 'react';

// material-ui
import {Alert, Card, CardContent, Checkbox, Chip, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Stack} from '@mui/material/';
import {blue} from '@mui/material/colors';
import EmailLog from '../../../dataObjects/EmailLog';
import { AuditorCommunicationContext } from '../view-archer';

interface Props {
    failedEmailLogs?: EmailLog[];
    markLetterRecipientAsReviewed: (letterRecipientId: number) => void;
}

const DashboardEmailLogs = (props: Props) => {
    //initial state setup
    const context = useContext(AuditorCommunicationContext);

    const setCurrentLetterCpfId = (cpfId: number) => {
        context.setCurrentLetterCpfId(cpfId);
    }

    const setCurrentCpfIdAndLetterId = (cpfId: number, letterId: number) => {
        context.setCurrentLetterCpfId(cpfId);
        context.setCurrentLetterId(letterId);
    }

    const markLetterRecipientAsReviewed = (letterRecipientId: number) => {
        props.markLetterRecipientAsReviewed(letterRecipientId);
    }

    return (
        <div>
            <Card className="dashboard-tile">
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container alignContent="center" justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="subtitle1" color="blue">Failed Email Deliveries {props.failedEmailLogs && `(${props.failedEmailLogs.length})`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} >
                            {
                                props.failedEmailLogs && props.failedEmailLogs.length === 0 &&
                                <Alert severity="success" sx={{ margin: 2 }}>There are no recent failed emails!</Alert>
                            }
                            {
                                props.failedEmailLogs && props.failedEmailLogs.length > 0 &&
                                <TableContainer sx={{ maxHeight: 265, m: 1 }}>
                                    <Table stickyHeader size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Filer</TableCell>
                                                <TableCell>Sent Date</TableCell>
                                                <TableCell>Email Status</TableCell>
                                                <TableCell>Reviewed?</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                props.failedEmailLogs?.map((email: EmailLog) =>
                                                    <TableRow
                                                        key={email.letterRecipientId}
                                                    >
                                                        <TableCell className="is-clickable" onClick={() => setCurrentLetterCpfId(email.cpfId)}><strong>{email.cpfId} {email.filerFullName}</strong></TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" sx={{ color: blue[500] }} className="is-clickable" onClick={() => setCurrentCpfIdAndLetterId(email.cpfId, email.letterId)} >{email.letterTemplateCode} {email.date}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Tooltip title={`${email.recipientEmailAddress}: ${email.deliveryStatusMessage}`} placement="top">
                                                                <Chip sx={{ width: '220px', justifyContent: 'left'}} label={`failed - ${email.recipientEmailAddress}`} size="small" color="error" />
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Checkbox onClick={() => markLetterRecipientAsReviewed(email.letterRecipientId)} />
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }                      
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>

    )
}

export default DashboardEmailLogs;